const SPECIAL_CHARACTER_REGEX = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/

export const passwordPolicyMessages = {
  minimumLength: 'Password must be at least 8 characters',
  maximumLength: 'Password is too long',
  uppercase: 'Password must contain at least one uppercase letter',
  lowercase: 'Password must contain at least one lowercase letter',
  number: 'Password must contain at least one number (0-9)',
  special: 'Password must contain at least one special character (e.g. !@#$%^&*()_+)',
  boundaryWhitespace: 'Password must not start or end with spaces',
} as const

export const passwordPolicyRequirements = [
  'At least 8 characters',
  'No more than 72 characters',
  'At least one number (0-9)',
  'At least one special character (e.g. !@#$%^&*()_+)',
  'At least one uppercase letter',
  'At least one lowercase letter',
  'No leading or trailing spaces',
] as const

export function validatePasswordPolicy(password: string): string | null {
  const byteLength = new TextEncoder().encode(password).length

  if (byteLength < 8) {
    return passwordPolicyMessages.minimumLength
  }
  if (byteLength > 72) {
    return passwordPolicyMessages.maximumLength
  }
  if (/^\s|\s$/.test(password)) {
    return passwordPolicyMessages.boundaryWhitespace
  }
  if (!/[A-Z]/.test(password)) {
    return passwordPolicyMessages.uppercase
  }
  if (!/[a-z]/.test(password)) {
    return passwordPolicyMessages.lowercase
  }
  if (!/\d/.test(password)) {
    return passwordPolicyMessages.number
  }
  if (!SPECIAL_CHARACTER_REGEX.test(password)) {
    return passwordPolicyMessages.special
  }

  return null
}
